// extracted by mini-css-extract-plugin
export default {"table":"Table_table__Rf4mU","mobile_view_table":"Table_mobile_view_table__sMlfu","pagination":"Table_pagination__ShLyo"};